import React from 'react';
import { motion } from 'framer-motion';

const ToggleSwitch = ({ enabled, onChange, label, description, color = 'blue', icon }) => {
  const colors = {
    blue: { track: 'bg-blue-500', ring: 'ring-blue-300' },
    green: { track: 'bg-green-500', ring: 'ring-green-300' },
    purple: { track: 'bg-purple-500', ring: 'ring-purple-300' },
  };
  const c = colors[color] || colors.blue;

  return (
    <div className="flex items-center justify-between py-3 px-4 bg-gray-50 rounded-xl border border-gray-200 hover:bg-gray-100 transition-colors">
      <div className="flex items-center gap-3 flex-1 min-w-0 mr-4">
        <span className="text-xl flex-shrink-0">{icon}</span>
        <div className="min-w-0">
          <p className="text-sm font-bold text-gray-800">{label}</p>
          <p className="text-xs text-gray-500 truncate">{description}</p>
        </div>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <span className={`text-xs font-semibold ${enabled ? 'text-gray-800' : 'text-gray-400'}`}>
          {enabled ? 'ON' : 'OFF'}
        </span>
        <button
          type="button"
          onClick={() => onChange(!enabled)}
          aria-pressed={enabled}
          aria-label={`${label} toggle`}
          className={`relative w-12 h-6 rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-1 ${c.ring} ${enabled ? c.track : 'bg-gray-300'}`}
        >
          <motion.span
            layout
            transition={{ type: 'spring', stiffness: 500, damping: 30 }}
            className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow-md ${enabled ? 'left-6' : 'left-0.5'}`}
          />
        </button>
      </div>
    </div>
  );
};

export default ToggleSwitch;